// extracted by mini-css-extract-plugin
module.exports = {"container":"RepoList_container__SkTIa","error":"RepoList_error__1IYJ6"};